module.exports = __webpack_public_path__ + "static/media/Spinner.07401652.gif";